<template>
        <span>
        <span v-if="currentRoute === 'nation'">
          <JsonExcel :data="nationDataArray" name="nation.csv" type="csv" :fields="nationFields">
          <b-icon-download class="shareIcons" />
          </JsonExcel>
        </span>
        <span v-if="currentRoute === 'state'">
          <JsonExcel :fields="{'Vaccination Goal': 'goal','Cases': 'cases', 'Cases Averted': 'casesAverted','Deaths': 'deaths','Deaths Averted':'deathsAverted'}" :data="stateDataArray" name="state.csv" type="csv" >
          <b-icon-download class="shareIcons" />
          </JsonExcel>
        </span>
        <span v-if="currentRoute === 'county'">
          <JsonExcel :fields="{'Vaccination Goal': 'goal','Cases': 'cases', 'Cases Averted': 'casesAverted','Deaths': 'deaths','Deaths Averted':'deathsAverted'}" :data="countyDataArray" name="county.csv" type="csv" >
          <b-icon-download class="shareIcons" />
          </JsonExcel>
        </span>
        <span v-if="currentRoute === 'personnel'">
          <JsonExcel v-if="personnelOption==='nation'" :fields="{'Site': 'jurisdiction','Population': 'population', 'Clinics': 'clinics', 'Total Workers': 'workers'}" :data="personnelNation" name="personnel-nation.csv" type="csv" >
          <b-icon-download class="shareIcons" />
          </JsonExcel>
          <JsonExcel v-if="personnelOption==='county'" :fields="{'Site': 'jurisdiction','Population': 'population', 'Clinics': 'clinics', 'Total Workers': 'workers'}" :data="personnelCounties" name="personnel-counties.csv" type="csv" >
          <b-icon-download class="shareIcons" />
          </JsonExcel>
        </span>
        </span>
</template>
<script>
import { BIconDownload } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import JsonExcel from "vue-json-excel";

import { mapState } from 'vuex';


export default {
  components: {
    BIconDownload,
    JsonExcel
  },
  computed: {
        ...mapState(['currentRoute','displayOutput','nationDataArray','stateDataArray','countyDataArray','personnelOption','personnelNation','personnelCounties','vaccinationRateLabel'])
    },
    data() {
      const label = this.$store.state.vaccinationRateLabel;
      let caseLabel = '';
      let deathLabel = '';
      if (label === 'Base Rate') {
        caseLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") Cases";
        deathLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") Deaths";
      }
      else {
        caseLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") " + this.$store.state.vaccinationRateLabel + " Cases";
        deathLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") " + this.$store.state.vaccinationRateLabel + " Deaths";
      }
        const nationFields =  {'Jurisdiction': 'name','Cases without Vaccination': 'noVaxCases'};
        nationFields[caseLabel] = 'withVaxCases';
        nationFields['Cases Averted'] = 'casesAverted';
        nationFields['Deaths without Vaccination'] = 'noVaxDeaths';
        nationFields[deathLabel] = 'withVaxDeaths';
        nationFields['Deaths Averted'] = 'deathsAverted';
      return {
        label: this.$store.state.vaccinationRateLabel,
        nationFields: nationFields
      }
    },
    watch: {
    nationDataArray: function() {
         const label = this.$store.state.vaccinationRateLabel;
      let caseLabel = '';
      let deathLabel = '';
      if (label === 'Base Rate') {
        caseLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") Cases";
        deathLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") Deaths";
      }
      else {
        caseLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") " + this.$store.state.vaccinationRateLabel + " Cases";
        deathLabel = "Base Rate (" + this.$store.state.vaccinationGoal + ") " + this.$store.state.vaccinationRateLabel + " Deaths";
      }
        const nationFields =  {'Jurisdiction': 'name','Cases without Vaccination': 'noVaxCases'};
        nationFields[caseLabel] = 'withVaxCases';
        nationFields['Cases Averted'] = 'casesAverted';
        nationFields['Deaths without Vaccination'] = 'noVaxDeaths';
        nationFields[deathLabel] = 'withVaxDeaths';
        nationFields['Deaths Averted'] = 'deathsAverted';
        this.nationFields = nationFields;
      }
    }
}
</script>